export default __webpack_public_path__ + "1b2d2f2b719ccff66bd66c997d132a02.svg";